import { Flame, Thermometer, Snowflake } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function LeadScoreBadge({ score }) {
  const s = score ?? 0;
  const isHot  = s >= 70;
  const isWarm = s >= 40;

  return (
    <span className={cn('inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium',
      isHot  ? 'bg-red-100 text-red-700' :
      isWarm ? 'bg-yellow-100 text-yellow-700' :
               'bg-blue-100 text-blue-700'
    )}>
      {isHot  ? <Flame size={11} />       :
       isWarm ? <Thermometer size={11} /> :
                <Snowflake size={11} />}
      {s} · {isHot ? 'Hot' : isWarm ? 'Warm' : 'Cold'}
    </span>
  );
}
